import script from "./SelectScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectScreen.vue?vue&type=script&setup=true&lang=ts"

import "./SelectScreen.vue?vue&type=style&index=0&id=aeb75e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeb75e6a"]])

export default __exports__